import { render, staticRenderFns } from "./AffiliateCompaniesSetup.vue?vue&type=template&id=d33e03e2&scoped=true&"
import script from "./AffiliateCompaniesSetup.vue?vue&type=script&lang=js&"
export * from "./AffiliateCompaniesSetup.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateCompaniesSetup.vue?vue&type=style&index=0&id=d33e03e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33e03e2",
  null
  
)

export default component.exports